module.exports = __webpack_public_path__ + "static/entreprises-fa7bc741d9f953f2970cc2f60d458cdd.jpg";